import React from 'react';
import TitleSection from '../../component/title';
import './style.css'

const Contact=()=>{
    return (
        <section className='contact' id='contact'>
            <TitleSection>Contact</TitleSection>
            <div className="contact-container">
                <div className="contact-content">
                    <h3 className="contact-subtitle">EMAIL</h3>
                    <span className="contact-text">getupacademyid@gmail.com</span>
                    <h3 className="contact-subtitle">PHONE</h3>
                    <span className="contact-text">+62 821-8874-3113</span>
                    <h3 className="contact-subtitle">ADRESS</h3>
                    <span className="contact-text">Jakarta, Kelapa Gading</span>
                </div>
                <div className="contact-form">
                    <form action="" className="contact-form">
                        <div className="contact-inputs">
                            <input type="text" placeholder="Name" className="contact-input"/>
                            <input type="mail" placeholder="Email" className="contact-input"/>
                        </div>
                        <textarea name="" id="" cols="0" rows="10" className="contact-input"></textarea>
                        <input type="submit" value="Send" className="contact-button"/>
                    </form>
                </div>
            </div>
        </section>
    )
}

export default Contact